export { default as WorkPacks } from './WorkPacksContainer.vue';
export { default as WorkPackItems } from './WorkPackItemsContainer.vue';
export { default as WorkPackParts } from './WorkPackPartsContainer.vue';
export { default as WorkPackViews } from './WorkPackViewsContainer.vue';
